import styled from "styled-components";

export const Input = styled.input`
	background-color: var(--color-brand-2);
	color: var(--color-gray-3);
	padding: 8px;
	font-family: var(--font-family);
	font-weight: var(--fw-semibold);
	border: none;
	border-radius: 0.2rem;

	transition: all 0.3s ease;

	&:focus {
		outline: none;
		background-color: var(--color-brand-5);
	}
`;
